import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: 'office/formal/save',
    data: from,
    method: 'post'
})
